import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export function useProp<T>(prop: string, defaultValue?: T) {
    const page = usePage();

    return computed<T>(() => {
        console.log(page.props);
        if (page.props[prop]) {
            return page.props[prop] as T;
        }

        return defaultValue as T;
    });
}
